"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateWeightedAverageConcentrationLimitKickouts = exports.sortReceivables = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const sortReceivables = ({ receivables, limitType, }) => {
    // add secondary sort on ASC 'eligibleExposureLessConcentrationLimitKickouts' as aligned here
    // https://finleytechnologies.slack.com/archives/C02HVEP2AF5/p1668737804540669
    return lodash_1.default.orderBy(receivables, [
        ({ value }) => value,
        ({ eligibleExposureLessConcentrationLimitKickouts }) => eligibleExposureLessConcentrationLimitKickouts,
    ], [limitType === 'max' ? 'desc' : 'asc', 'asc']);
};
exports.sortReceivables = sortReceivables;
/**
 * Greedy algorithm solves by:
 * 1) sorting receivables by concentration limit property (value), then by weight (eligibleExposureLessConcentrationLimitKickouts)
 * 2) discretely removing the largest breaching receivables until weighted average meets concentration limit threshold
 */
const calculateWeightedAverageConcentrationLimitKickouts = ({ receivables, limitType, concentrationLimit, }) => {
    // first sort by the value we want to measure against
    const sortedReceivables = (0, exports.sortReceivables)({ limitType, receivables });
    // make a copy, as we will mutate weightedAverageReceivables length
    // while looping through sortedReceivables
    const weightedAverageReceivables = [...sortedReceivables];
    // remove excess concentration by removing one loan record at a time
    // and checking against new weighted average value
    // since it's sorted, we can exit early once we're in the "clear" of our concentration limit
    const kickouts = {};
    sortedReceivables.every((rec) => {
        const weightedAverage = common_1.utils.calculateWeightedAverage(weightedAverageReceivables, { roundingPrecision: 10 });
        switch (limitType) {
            case 'min': {
                if (weightedAverage >= concentrationLimit) {
                    return false;
                }
                break;
            }
            case 'max':
                if (weightedAverage <= concentrationLimit) {
                    return false;
                }
                break;
            default:
                throw Error(`unknown limitType ${limitType}`);
        }
        kickouts[rec.finleyReceivableId] =
            rec.eligibleExposureLessConcentrationLimitKickouts;
        weightedAverageReceivables.shift();
        // return true only if there are more receivables that can be kicked out.
        // once we kickout everything return false;
        return weightedAverageReceivables.length > 0;
    });
    return kickouts;
};
exports.calculateWeightedAverageConcentrationLimitKickouts = calculateWeightedAverageConcentrationLimitKickouts;
//# sourceMappingURL=greedy.js.map